import { Component } from '@verndale/core';
import VidyardEmbed from '@vidyard/embed-code';

type VidyardPlayer = {
  on: (event: string, cb: () => void) => void;
  showLightbox: () => void;
  setVolume: (newVolume: number) => void;
  play: () => void;
  pause: () => void;
};

class VideoButton extends Component {
  private player: VidyardPlayer | null = null;
  private isPlaying = false;
  private isLoaded = false;
  private lightbox = 'false';
  private uuid = '';

  constructor(el: HTMLElement) {
    super(el);
    const { background } = this.el.dataset;
    this.lightbox = this.el.dataset.lightbox || 'false';
    this.uuid = (this.dom.image as HTMLElement).dataset.uuid || '';

    if (background === 'true') {
      this.loadPlayer(background);
    }
    if (this.lightbox === 'true') {
      (this.dom.image as HTMLElement).removeAttribute('data-uuid');
      this.buildHTML();
    }
  }

  setupDefaults() {
    this.dom = {
      body: document.querySelector<HTMLElement>('body'),
      button: this.el.querySelector<HTMLElement>('.video-button__button'),
      image: this.el.querySelector<HTMLElement>('.video-button__embed'),
      title: this.el.querySelector<HTMLElement>('.video-button__title')
    };
  }

  addListeners() {
    if (this.dom.button) {
      (this.dom.button as HTMLButtonElement).addEventListener(
        'click',
        this.handleButtonClick.bind(this)
      );

      if (this.dom.image) {
        (this.dom.image as HTMLButtonElement).addEventListener(
          'click',
          this.handleButtonClick.bind(this)
        );
      }

      if (this.dom.title) {
        (this.dom.title as HTMLButtonElement).addEventListener(
          'click',
          this.handleButtonClick.bind(this)
        );
      }
    }
  }

  buildHTML() {
    document.querySelectorAll('.video-button__modal').forEach(modal => {
      modal.remove();
    });
    this.dom.videoModal = document.createElement('div');
    this.dom.videoModal.setAttribute('role', 'dialog');
    this.dom.videoModal.setAttribute(
      'aria-label',
      (this.dom.title as HTMLElement)?.innerText || 'Video Modal'
    );
    this.dom.videoModal.classList.add('video-button__modal');
    (this.dom.body as HTMLBodyElement).appendChild(this.dom.videoModal);
  }

  async loadPlayer(background?: string) {
    if (this.lightbox === 'false')
      this.player = await VidyardEmbed.api.renderPlayer(this.dom.image);
    else if (this.lightbox === 'true') {
      this.player = await VidyardEmbed.api.renderPlayer({
        uuid: this.uuid,
        container: this.dom.videoModal,
        autoplay: '1',
        type: 'lightbox'
      });
      this.player?.showLightbox();
      this.player?.on('lightboxClose', () => {
        this.handlePlayPause(false);
      });
    }
    this.isLoaded = true;

    if (background === 'true' || this.lightbox === 'true') {
      if (background === 'true') this.player?.setVolume(0);
      this.player?.on('play', () => {
        this.handlePlayPause(true);
      });
      this.player?.on('pause', () => {
        this.handlePlayPause(false);
      });
    } else {
      this.el.dataset.inlineVideoLoaded = 'true';
    }
    this.player?.on('play', () => {
      this.handlePlayPause(true);
    });

    this.player?.play();
  }

  handleButtonClick() {
    if (!this.isLoaded) {
      this.loadPlayer();
    } else if (this.isPlaying) {
      this.player?.pause();
    } else {
      if (this.lightbox === 'true') this.player?.showLightbox();
      this.player?.play();
    }
  }

  handlePlayPause(isPlaying: boolean) {
    this.isPlaying = isPlaying;
    this.el.dataset.isPlaying = `${isPlaying}`;
  }
}

export default VideoButton;
